import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import { datadogRum } from "@datadog/browser-rum";
var windowIsAvailable = "object" !== "undefined";
export var writeEmailToSessionStorage = function(email) {
    if (!windowIsAvailable) return null;
    try {
        var emailEncoded = Buffer.from(email).toString("base64");
        window.sessionStorage.setItem("crm_enrichment:email", emailEncoded);
        return;
    } catch (error) {
        handlerError(error, "Write");
        return;
    }
};
export var readEmailFromSessionStorage = function() {
    if (!windowIsAvailable) return null;
    try {
        var emailEncoded = window.sessionStorage.getItem("crm_enrichment:email");
        return emailEncoded ? Buffer.from(emailEncoded, "base64").toString() : null;
    } catch (error) {
        handlerError(error, "Read");
        return null;
    }
};
var handlerError = function(error, type) {
    if (_instanceof(error, Error)) {
        datadogRum.addError(error, {
            service: "Customer Data - Segment Enrichment - ".concat(type, " Email Session Storage"),
            squad: "customer-data"
        });
    } else {
        datadogRum.addError(new Error("Unknown error - ".concat(type, " Email Session Storage")), {
            service: "Customer Data - Segment Enrichment - ".concat(type, " Email Session Storage"),
            squad: "customer-data"
        });
    }
};
